/**
 * "Add to Cyrano" bookmarklet.
 *
 * Produces a self-contained `javascript:` URL that, when clicked on any web
 * page (tuned for Reddit — both shreddit and old.reddit — but works generally),
 * scans the DOM for animated/GIF media, lets the user pick one if several are
 * present, and opens `<origin>/admin/quick-add?url=<url>` in a small top-right
 * popup window that auto-submits the upload and shows its status (spinner →
 * success ✓, self-closing, or an error with a retry link).
 *
 * The body below is authored as a readable, ES2017-safe script and then wrapped
 * into an encoded IIFE by `buildBookmarklet`.
 */

const BOOKMARKLET_BODY = `
var ORIGIN = __ORIGIN__;

var openInCyrano = function (u) {
  // Anchor to the top-right of the Chrome window (not the monitor): the
  // opener page knows the browser window's desktop position and size.
  var popupW = 390;
  var left = Math.max(0, window.screenX + window.outerWidth - popupW - 16);
  var top = window.screenY + 88;
  window.open(
    ORIGIN + '/admin/quick-add?url=' + encodeURIComponent(u),
    'cyrano_quick_add',
    'popup=yes,width=' + popupW + ',height=200,left=' + left + ',top=' + top
  );
};

// 1. Collect candidate media elements + their URLs. New Reddit (shreddit)
// hides comment media inside nested shadow roots (shreddit-player etc.), so
// the walk must recurse into every shadowRoot, not just the light DOM.
var candidates = [];
var pushCandidate = function (el, url) {
  if (el && url) candidates.push({ el: el, url: url });
};

var collectFromRoot = function (root, depth) {
  if (!root || depth > 25) return;

  var imgs = root.querySelectorAll('img');
  for (var i = 0; i < imgs.length; i++) {
    pushCandidate(imgs[i], imgs[i].currentSrc || imgs[i].src);
  }

  var sources = root.querySelectorAll('source');
  for (var s = 0; s < sources.length; s++) {
    var src = sources[s];
    var srcUrl = src.src;
    if (!srcUrl && src.srcset) {
      srcUrl = src.srcset.split(',')[0].trim().split(' ')[0];
    }
    pushCandidate(src.parentElement || src, srcUrl);
  }

  var videos = root.querySelectorAll('video');
  for (var v = 0; v < videos.length; v++) {
    var vid = videos[v];
    pushCandidate(vid, vid.poster);
    pushCandidate(vid, vid.currentSrc || vid.src);
  }

  var all = root.querySelectorAll('*');
  for (var a = 0; a < all.length; a++) {
    if (all[a].shadowRoot) collectFromRoot(all[a].shadowRoot, depth + 1);
  }
};

collectFromRoot(document, 0);

// 2. Keep only URLs that look like animated / GIF media.
var hostOk = function (h) {
  if (
    h === 'i.redd.it' ||
    h === 'preview.redd.it' ||
    h === 'external-preview.redd.it' ||
    h === 'packaged-media.redd.it'
  ) {
    return true;
  }
  if (/^media\\d*\\.giphy\\.com$/.test(h)) return true;
  if (/(^|\\.)tenor\\.com$/.test(h)) return true;
  return false;
};

var isExcludedUrl = function (lower) {
  return /avatar|profileicon|styles\\.redditmedia|emoji|award|redditstatic|rlcdn|doubleclick|adsystem|analytics|pixel/.test(
    lower
  );
};

var keep = function (url, el) {
  if (!url) return false;
  var lower = url.toLowerCase();
  if (isExcludedUrl(lower)) return false;

  var host = '';
  var path = '';
  var query = '';
  try {
    var a = document.createElement('a');
    a.href = url;
    host = a.hostname.toLowerCase();
    path = a.pathname.toLowerCase();
    query = a.search.toLowerCase();
  } catch (e) {
    return false;
  }

  // Animated media only: .gif/.mp4/.webm path, or an mp4/gif rendition
  // requested via query (Reddit preview CDNs serve static jpeg/png too).
  var animated =
    /\\.(gif|mp4|webm)$/.test(path) || /format=(mp4|gif)/.test(query);
  if (!animated) return false;
  if (!hostOk(host) && !/\\.(gif|mp4|webm)$/.test(path)) return false;

  var w = el && el.clientWidth ? el.clientWidth : 0;
  var h = el && el.clientHeight ? el.clientHeight : 0;
  if (w > 0 && w < 80) return false;
  if (h > 0 && h < 80) return false;

  return true;
};

// 3. Dedupe by URL.
var seen = {};
var list = [];
for (var c = 0; c < candidates.length; c++) {
  var cand = candidates[c];
  if (!keep(cand.url, cand.el)) continue;
  if (seen[cand.url]) continue;
  seen[cand.url] = 1;
  list.push(cand);
}

// Compute viewport visibility for each kept element.
var isVisible = function (el) {
  if (!el || !el.getBoundingClientRect) return false;
  var r = el.getBoundingClientRect();
  var vw = window.innerWidth || document.documentElement.clientWidth;
  var vh = window.innerHeight || document.documentElement.clientHeight;
  return r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
};

// 4. Nothing found.
if (list.length === 0) {
  alert('Add to Cyrano: no GIFs found on this page.');
  return;
}

// 5. Exactly one candidate (or exactly one visible while the rest are offscreen).
if (list.length === 1) {
  openInCyrano(list[0].url);
  return;
}
var visible = [];
for (var vv = 0; vv < list.length; vv++) {
  if (isVisible(list[vv].el)) visible.push(list[vv]);
}
if (visible.length === 1) {
  openInCyrano(visible[0].url);
  return;
}

// 6. Otherwise, show a picker overlay.
var container = document.createElement('div');
container.style.position = 'absolute';
container.style.top = '0';
container.style.left = '0';
container.style.zIndex = '2147483000';

var cleanup = function () {
  if (container && container.parentNode) {
    container.parentNode.removeChild(container);
  }
  document.removeEventListener('keydown', onKey);
};

var onKey = function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) cleanup();
};
document.addEventListener('keydown', onKey);

var makePill = function (label) {
  var b = document.createElement('button');
  b.textContent = label;
  b.style.position = 'absolute';
  b.style.zIndex = '2147483000';
  b.style.background = '#111827';
  b.style.color = '#ffffff';
  b.style.border = 'none';
  b.style.borderRadius = '999px';
  b.style.padding = '4px 10px';
  b.style.fontSize = '12px';
  b.style.fontFamily = 'sans-serif';
  b.style.lineHeight = '1.4';
  b.style.cursor = 'pointer';
  b.style.boxShadow = '0 1px 4px rgba(0,0,0,0.4)';
  return b;
};

for (var b = 0; b < list.length; b++) {
  (function (item) {
    var r = item.el.getBoundingClientRect();
    var badge = makePill('\\u2795 Cyrano');
    badge.style.top = r.top + window.scrollY + 4 + 'px';
    badge.style.left = r.left + window.scrollX + 4 + 'px';
    badge.onclick = function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      cleanup();
      openInCyrano(item.url);
    };
    container.appendChild(badge);
  })(list[b]);
}

var cancel = makePill('Cancel \\u2715');
cancel.style.position = 'fixed';
cancel.style.top = '12px';
cancel.style.right = '12px';
cancel.style.left = 'auto';
cancel.onclick = function (ev) {
  ev.preventDefault();
  cleanup();
};
container.appendChild(cancel);

document.body.appendChild(container);
`

/**
 * Build the `javascript:` bookmarklet URL for the given Cyrano origin.
 * The origin is baked in so the bookmark works from the user's bookmarks bar
 * on any page and always targets this Cyrano deployment.
 */
export function buildBookmarklet(origin: string): string {
  const body = BOOKMARKLET_BODY.replace('__ORIGIN__', JSON.stringify(origin))
  return 'javascript:' + encodeURIComponent('(()=>{' + body + '})()')
}
